import Company from "./icons/licenses/company.svg";
import Ultimate from "./icons/licenses/ultimate.svg";
import Product from "./icons/licenses/product.svg";
import DevTeam from "./icons/licenses/devteam.svg";

const link = "http://webix.com/legalnote/developer-license-agreement/";

const licenses = [
	{
		name: "Custom Pack",
		descr:
			"Select your own set of Widgets, number of developers and support plan",
		// code: [ 28751279 ],
		code: ["wbx-custom"],
		link,
		licenseLink: "/legalnote/webix-commercial/#i-grant-of-license",
		package: "3 complex Widgets",
		projects: 1,
		devs: 2,
		maxDevs: 2,
		support: "standard",
		supportOptions: ["standard", "priority"],
		price: 848,
		widgets: 0,
		sas: false,
		logo: Product,
		id: "custom",
	},
	{
		name: "Company Pack",
		descr:
			"Perfect for internal company projects or a single commercial project.",
		// code: [ 28751274 ],
		code: ["wbx-company"],
		link,
		licenseLink: "/legalnote/webix-company-license/",
		package: "All complex Widgets",
		projects: 1,
		devs: Infinity,
		support: "standard",
		supportOptions: ["standard", "priority"],
		price: 2499,
		widgets: Infinity,
		sas: true,
		logo: Company,
		id: "company",
	},
	{
		name: "DevTeam Pack",
		descr:
			"Perfect for development companies that work on projects for multiple clients.",
		// code: [ 28751267 ],
		code: ["wbx-devteam"],
		link,
		licenseLink: "/legalnote/webix-devteam-license/",
		package: "All complex Widgets",
		projects: Infinity,
		devs: 5,
		maxDevs: 16,
		extraDevPrice: 449,
		extraDevCode: "wbx-devteam-dev", // 28751367,
		support: "standard",
		supportOptions: ["standard", "priority"],
		price: 3999,
		widgets: Infinity,
		sas: true,
		logo: DevTeam,
		id: "devteam",
	},
	{
		name: "Unlim Pack",
		descr:
			"Perfect for large development companies with multiple projects and large teams.",
		// code: [ 28751258 ],
		code: ["wbx-unlim"],
		link,
		licenseLink: "/legalnote/webix-unlimited-license/",
		package: "All complex Widgets",
		projects: Infinity,
		devs: Infinity,
		support: "priority",
		supportOptions: ["priority"],
		price: 9499,
		widgets: Infinity,
		sas: true,
		logo: Ultimate,
		id: "ultimate",
	},
];

const supports = {
	basic: {
		code: [],
		id: "basic",
		name: "Basic",
		tickets: 10,
		hours: 72,
		price: 0,
	},
	standard: {
		// code: [ 31381537 ],
		code: ["wbx-sup-standard"],
		id: "standard",
		name: "Standard",
		tickets: 30,
		hours: 48,
		price: 299,
	},
	priority: {
		// code: [ 31381553 ],
		code: ["wbx-sup-priority"],
		id: "priority",
		name: "Priority",
		tickets: Infinity,
		hours: 24,
		price: 599,
	},
};

const products = {
	chat: {
		id: "chat",
		name: "Chat / Messenger",
		price: 499,
		// code:[ 31381151 ]
		code: ["wbx-chat"],
	},
	filemanager: {
		id: "filemanager",
		name: "File Manager + Doc Manager",
		price: 199,
		// code:[ 28751166 ]
		code: ["wbx-filemanager"],
	},
	kanban: {
		id: "kanban",
		name: "Kanban",
		price: 199,
		// code:[ 28751172 ]
		code: ["wbx-kanban"],
	},
	pivot: {
		id: "pivot",
		name: "Pivot",
		price: 499,
		// code:[ 28751154 ]
		code: ["wbx-pivot"],
	},
	scheduler: {
		id: "scheduler",
		name: "Scheduler",
		price: 499,
		// code:[ 28751178 ]
		code: ["wbx-scheduler"],
	},
	spreadsheet: {
		id: "spreadsheet",
		name: "SpreadSheet",
		price: 499,
		// code:[ 28010914 ]
		code: ["wbx-spreadsheet"],
	},
	query: {
		id: "query",
		name: "Query",
		price: 199,
		// code:[ 31381448 ]
		code: ["wbx-query"],
	},
	usermanager: {
		id: "usermanager",
		name: "User Manager",
		price: 199,
		// code:[ 31381456 ]
		code: ["wbx-user-manager"],
	},
	gantt: {
		id: "gantt",
		name: "Gantt Chart",
		price: 499,
		code: ["wbx-gantt"],
	},
	reportmanager: {
		id: "reportmanager",
		name: "Report Manager",
		price: 499,
		code: ["wbx-reports"],
	},
	diagram: {
		id: "diagram",
		name: "Diagram Library",
		price: 499,
		// code:[ 35465422 ]
		code: ["wbx-diagram"],
	},
};

const productsList = [
	products.pivot,
	products.filemanager,
	products.kanban,
	products.query,
	products.scheduler,
	products.usermanager,
	products.chat,
	products.spreadsheet,
	products.gantt,
	products.reportmanager,
	products.diagram,
];

const licenseCost = {};
licenses.forEach(a => {
	a._devs = a.devs;
	a._price = a.price;
	a._support = a.support;
	licenseCost[a.id] = a.price;
});

const purchaseCodes = {
	"wbx-company": 42450,
	"wbx-devteam": 42454,
	"wbx-unlim": 42455,
	"wbx-devteam-dev": 60051,
	"wbx-sup-priority": 42468,
};

function customBuyLink(core, widgets, devs, support, coupon) {
	return `/actions/purchase?core=${
		core ? 1 : 0
	}&devs=${devs}&widgets=${Object.keys(widgets).join(":")}&support=${
		support === "standard" ? 0 : 1
	}&coupon=${coupon}`;
}

function buyLink(now, support, devs, coupon) {
	let codes = [].concat(now.code);
	support = support || now.support;
	if (now._support !== support) codes = codes.concat(supports[support].code);

	devs = devs || now.devs;
	const qys = codes.map(() => 1);
	if (now._devs !== devs) {
		codes.push(now.extraDevCode);
		qys.push(devs - now._devs);
	}

	let sufix = "?currency=USD";
	codes.forEach((a, i) => {
		sufix += `&products[${i + 1}][id]=${purchaseCodes[a]}&products[${
			i + 1
		}][qty]=${qys[i] || 1}`;
	});
	if (coupon) sufix += `&coupon=${coupon}`;

	return "https://store.payproglobal.com/checkout" + sufix;
}

function buyPrice(now, support, devs, widgets) {
	support = support || now.support;
	devs = devs || now.devs;

	let price =
		now._price +
		(now._support != support ? supports[support].price : 0) +
		(now._devs != devs ? (devs - now._devs) * now.extraDevPrice : 0);

	if (now.widgets != Infinity && widgets) {
		price += []
			.concat(productsList)
			.filter(a => widgets[a.id])
			.sort((a, b) => (a.price > b.price ? -1 : 1))
			.slice(now.widgets)
			.reduce((a, b) => a + b.price, 0);
	}

	return price;
}

export {
	licenses,
	licenseCost,
	supports,
	products,
	productsList,
	buyLink,
	customBuyLink,
	buyPrice,
};
